<template>
    <div class="animated fadeIn">     
        <b-card>
            <div slot="header">Report Annual Budget vs Realization 
                <div class="card-header-actions">
                    <button class="btn btn-primary mr-1" @click="exportxls()">
                        <i class="fa fa-file-excel-o"></i>
                        Export
                    </button>
                  <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                </div>
            </div>
            <!-- <b-row >
                <b-col lg="4">
                  <b-input-group >
                        <b-input-group-prepend><label>Date Range</label></b-input-group-prepend>
                        <b-form-input v-model="filter.tgl1" type="date" readonly></b-form-input>
                        <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
                        <b-form-input v-model="filter.tgl2" type="date" @change="updateTgl1" :state="!$v.filter.tgl2.$error"></b-form-input>
                  </b-input-group>
                </b-col>
                <b-col lg="3">
                    <b-input-group >
                        <b-input-group-prepend><span class="pt-2 mr-2">Line Layout</span></b-input-group-prepend>
                        <b-form-select v-model="filter.layout" :plain="true" :options="layouts" :state="!$v.filter.layout.$error"></b-form-select>
                    </b-input-group>
                </b-col>
            </b-row >
            <b-row >
                <b-col lg="7">
                    <b-input-group>
                        <b-input-group-prepend><label>Dept/Div/Dir</label></b-input-group-prepend>
                        <b-form-select v-model="filter.DimCol" :plain="true" :options="['Department','Division','Directorat']"></b-form-select>
                        <b-form-input v-model="filter.departemen" placeholder="Value" class="ml-1" disabled :state="!$v.filter.departkd.$error"></b-form-input>
                        <b-input-group-append>
                        <b-btn text="Button" @click="lkuDeptShow=true" >
                            <i class="fa fa-search"></i>
                        </b-btn>
                        </b-input-group-append>
                    </b-input-group>
                </b-col>
                <b-col lg="1">
                    <b-button class="btn btn-success" @click="process()" > <i class="fa fa-play"></i> Process</b-button>
                </b-col>
            </b-row > -->
            <b-row >
                <b-col lg="6" xl="4">
                  <b-input-group >
                        <b-input-group-prepend><label>Date Range</label></b-input-group-prepend>
                        <b-form-input v-model="filter.tgl1" type="date" readonly></b-form-input>
                        <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
                        <b-form-input v-model="filter.tgl2" type="date" @change="updateTgl1" :state="!$v.filter.tgl2.$error"></b-form-input>
                  </b-input-group>
                </b-col>
                <b-col lg="4" xl="3">
                    <b-input-group >
                        <b-input-group-prepend><span class="pt-2 mr-2">Line Layout</span></b-input-group-prepend>
                        <b-form-select v-model="filter.layout" :plain="true" :options="layouts" :state="!$v.filter.layout.$error"></b-form-select>
                    </b-input-group>
                </b-col>
            </b-row >
            <b-row >
                <b-col lg="10" xl="8">
                  <b-input-group >
                        <b-input-group-prepend><label>Dept/Div/Dir</label></b-input-group-prepend>
                        <b-form-radio-group  class="mt-2" v-model="filter.opsiDept" name="radioDept" :state="!$v.filter.opsiDept.$error">
                            <b-form-radio value="1">All</b-form-radio>
                            <b-form-radio value="2">Empty (Non Dept)</b-form-radio>
                            <b-form-radio value="3">Choice</b-form-radio>
                        </b-form-radio-group>
                        <b-form-select v-model="filter.DimCol" :state="!$v.filter.DimCol.$error" :plain="true" :options="['Department','Division','Directorat']" :disabled="(filter.opsiDept!=3)"></b-form-select>
                        <b-form-input v-model="filter.departemen" :state="!$v.filter.departkd.$error" placeholder="Value" class="ml-1" disabled style="width:27%"></b-form-input>
                        <b-input-group-append v-if="(filter.opsiDept==3)">
                            <b-btn text="Button" @click="lkuDeptShow=true" >
                                <i class="fa fa-search"></i>
                            </b-btn>
                        </b-input-group-append>
                    </b-input-group>
                </b-col>
                <b-col lg="2" xl="1">
                    <b-button class="btn btn-success" @click="process()" > <i class="fa fa-play"></i> Process</b-button>
                </b-col>
            </b-row >
            <b-card no-body>
                <b-input-group >
                    <b-input-group-prepend><label> &nbsp;&nbsp;&nbsp;Hide Column   :</label></b-input-group-prepend>
                    <b-form-checkbox :value="false" :unchecked-value="true" v-model="JanShow" class="mt-1">Jan</b-form-checkbox>
                    <b-form-checkbox :value="false" :unchecked-value="true" v-model="FebShow" class="mt-1">Feb</b-form-checkbox>
                    <b-form-checkbox :value="false" :unchecked-value="true" v-model="MarShow" class="mt-1">Mar</b-form-checkbox>
                    <b-form-checkbox :value="false" :unchecked-value="true" v-model="AprShow" class="mt-1">Apr</b-form-checkbox>
                    <b-form-checkbox :value="false" :unchecked-value="true" v-model="MeiShow" class="mt-1">Mei</b-form-checkbox>
                    <b-form-checkbox :value="false" :unchecked-value="true" v-model="JunShow" class="mt-1">Jun</b-form-checkbox>
                    <b-form-checkbox :value="false" :unchecked-value="true" v-model="JulShow" class="mt-1">Jul</b-form-checkbox>
                    <b-form-checkbox :value="false" :unchecked-value="true" v-model="AgtShow" class="mt-1">Agt</b-form-checkbox>
                    <b-form-checkbox :value="false" :unchecked-value="true" v-model="SepShow" class="mt-1">Sep</b-form-checkbox>
                    <b-form-checkbox :value="false" :unchecked-value="true" v-model="OktShow" class="mt-1">Oct</b-form-checkbox>
                    <b-form-checkbox :value="false" :unchecked-value="true" v-model="NovShow" class="mt-1">Nov</b-form-checkbox>
                    <b-form-checkbox :value="false" :unchecked-value="true" v-model="DesShow" class="mt-1">Dec</b-form-checkbox>
                </b-input-group>
                <div class="report-wraper">
                    <table >
                        <thead>
                            <tr>
                                <th width="250px" rowspan="2">Description</th>
                                <th colspan="3" style="text-align:center;" v-if="JanShow">Jan {{filter.tahun}}</th>
                                <th colspan="3" style="text-align:center;" v-if="FebShow">Feb {{filter.tahun}}</th>
                                <th colspan="3" style="text-align:center;" v-if="MarShow">Mar {{filter.tahun}}</th>
                                <th colspan="3" style="text-align:center;" v-if="AprShow">Apr {{filter.tahun}}</th>
                                <th colspan="3" style="text-align:center;" v-if="MeiShow">Mei {{filter.tahun}}</th>
                                <th colspan="3" style="text-align:center;" v-if="JunShow">Jun {{filter.tahun}}</th>
                                <th colspan="3" style="text-align:center;" v-if="JulShow">Jul {{filter.tahun}}</th>
                                <th colspan="3" style="text-align:center;" v-if="AgtShow">Aug {{filter.tahun}}</th>
                                <th colspan="3" style="text-align:center;" v-if="SepShow">Sep {{filter.tahun}}</th>
                                <th colspan="3" style="text-align:center;" v-if="OktShow">Okt {{filter.tahun}}</th>
                                <th colspan="3" style="text-align:center;" v-if="NovShow">Nov {{filter.tahun}}</th>
                                <th colspan="3" style="text-align:center;" v-if="DesShow">Des {{filter.tahun}}</th>
                                <th colspan="3" style="text-align:center;">Year To Date</th>
                                <th colspan="3" style="text-align:center;">TOTAL</th>
                            </tr>
                            <tr>
                                <th style="text-align:center" width="100px" v-if="JanShow">Budget</th>
                                <th style="text-align:center" width="100px" v-if="JanShow">Actual</th>
                                <th style="text-align:center" width="100px" v-if="JanShow">Variant </th>
                                <th style="text-align:center" width="100px" v-if="FebShow">Budget</th>
                                <th style="text-align:center" width="100px" v-if="FebShow">Actual</th>
                                <th style="text-align:center" width="100px" v-if="FebShow">Variant </th>
                                <th style="text-align:center" width="100px" v-if="MarShow">Budget</th>
                                <th style="text-align:center" width="100px" v-if="MarShow">Actual</th>
                                <th style="text-align:center" width="100px" v-if="MarShow">Variant </th>
                                <th style="text-align:center" width="100px" v-if="AprShow">Budget</th>
                                <th style="text-align:center" width="100px" v-if="AprShow">Actual</th>
                                <th style="text-align:center" width="100px" v-if="AprShow">Variant </th>
                                <th style="text-align:center" width="100px" v-if="MeiShow">Budget</th>
                                <th style="text-align:center" width="100px" v-if="MeiShow">Actual</th>
                                <th style="text-align:center" width="100px" v-if="MeiShow">Variant </th>
                                <th style="text-align:center" width="100px" v-if="JunShow">Budget</th>
                                <th style="text-align:center" width="100px" v-if="JunShow">Actual</th>
                                <th style="text-align:center" width="100px" v-if="JunShow">Variant </th>
                                <th style="text-align:center" width="100px" v-if="JulShow">Budget</th>
                                <th style="text-align:center" width="100px" v-if="JulShow">Actual</th>
                                <th style="text-align:center" width="100px" v-if="JulShow">Variant </th>
                                <th style="text-align:center" width="100px" v-if="AgtShow">Budget</th>
                                <th style="text-align:center" width="100px" v-if="AgtShow">Actual</th>
                                <th style="text-align:center" width="100px" v-if="AgtShow">Variant </th>
                                <th style="text-align:center" width="100px" v-if="SepShow">Budget</th>
                                <th style="text-align:center" width="100px" v-if="SepShow">Actual</th>
                                <th style="text-align:center" width="100px" v-if="SepShow">Variant </th>
                                <th style="text-align:center" width="100px" v-if="OktShow">Budget</th>
                                <th style="text-align:center" width="100px" v-if="OktShow">Actual</th>
                                <th style="text-align:center" width="100px" v-if="OktShow">Variant </th>
                                <th style="text-align:center" width="100px" v-if="NovShow">Budget</th>
                                <th style="text-align:center" width="100px" v-if="NovShow">Actual</th>
                                <th style="text-align:center" width="100px" v-if="NovShow">Variant </th>
                                <th style="text-align:center" width="100px" v-if="DesShow">Budget</th>
                                <th style="text-align:center" width="100px" v-if="DesShow">Actual</th>
                                <th style="text-align:center" width="100px" v-if="DesShow">Variant </th>
                                <th style="text-align:center" width="100px">Budget</th>
                                <th style="text-align:center" width="100px">Actual</th>
                                <th style="text-align:center" width="100px">Variant </th>
                                <th style="text-align:center" width="100px">Budget</th>
                                <th style="text-align:center" width="100px">Actual</th>
                                <th style="text-align:center" width="100px">Variant </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="row in rptLines" :key="row.idrowunik">
                                <td :class="row.kelas"><div style="width: 250px; overflow: hidden; display: inline-block; white-space: nowrap;"><span v-html="row.uraianhtm"></span></div></td>
                                <td :class="row.kelas"  v-if="JanShow" style="text-align:right">
                                    <span v-if="row.kode || row.rumus">{{row.janB | numFormat}}</span>
                                </td>
                                <td :class="row.kelas"  v-if="JanShow" style="text-align:right">
                                    <b-link v-if="row.kode || row.rumus" @click="drillMonthly(row,row.jan,1)">{{row.jan | numFormat}}</b-link>
                                </td>
                                <td :class="row.kelas"  v-if="JanShow" style="text-align:right">
                                    <span v-if="row.kode || row.rumus">{{row.janV | numFormat}}</span>
                                </td>

                                <td :class="row.kelas"  v-if="FebShow" style="text-align:right">
                                    <span v-if="row.kode || row.rumus">{{row.febB | numFormat}}</span>
                                </td>
                                <td :class="row.kelas"  v-if="FebShow" style="text-align:right">
                                    <b-link v-if="row.kode || row.rumus" @click="drillMonthly(row,row.feb,2)">{{row.feb | numFormat}}</b-link>
                                </td>
                                <td :class="row.kelas"  v-if="FebShow" style="text-align:right">
                                    <span v-if="row.kode || row.rumus">{{row.febV | numFormat}}</span>
                                </td>

                                <td :class="row.kelas"  v-if="MarShow" style="text-align:right">
                                    <span v-if="row.kode || row.rumus">{{row.marB | numFormat}}</span>
                                </td>
                                <td :class="row.kelas"  v-if="MarShow" style="text-align:right">
                                    <b-link v-if="row.kode || row.rumus" @click="drillMonthly(row,row.mar,3)">{{row.mar | numFormat}}</b-link>
                                </td>
                                <td :class="row.kelas"  v-if="MarShow" style="text-align:right">
                                    <span v-if="row.kode || row.rumus">{{row.marV | numFormat}}</span>
                                </td>

                                <td :class="row.kelas"  v-if="AprShow" style="text-align:right">
                                    <span v-if="row.kode || row.rumus">{{row.aprB | numFormat}}</span>
                                </td>
                                <td :class="row.kelas"  v-if="AprShow" style="text-align:right">
                                    <b-link v-if="row.kode || row.rumus" @click="drillMonthly(row,row.apr,4)">{{row.apr | numFormat}}</b-link>
                                </td>
                                <td :class="row.kelas"  v-if="AprShow" style="text-align:right">
                                    <span v-if="row.kode || row.rumus">{{row.aprV | numFormat}}</span>
                                </td>

                                <td :class="row.kelas"  v-if="MeiShow" style="text-align:right">
                                    <span v-if="row.kode || row.rumus">{{row.meiB | numFormat}}</span>
                                </td>
                                <td :class="row.kelas"  v-if="MeiShow" style="text-align:right">
                                    <b-link v-if="row.kode || row.rumus" @click="drillMonthly(row,row.mei,5)">{{row.mei | numFormat}}</b-link>
                                </td>
                                <td :class="row.kelas"  v-if="MeiShow" style="text-align:right">
                                    <span v-if="row.kode || row.rumus">{{row.meiV | numFormat}}</span>
                                </td>

                                <td :class="row.kelas"  v-if="JunShow" style="text-align:right">
                                    <span v-if="row.kode || row.rumus">{{row.junB | numFormat}}</span>
                                </td>
                                <td :class="row.kelas"  v-if="JunShow" style="text-align:right">
                                    <b-link v-if="row.kode || row.rumus" @click="drillMonthly(row,row.jun,6)">{{row.jun | numFormat}}</b-link>
                                </td>
                                <td :class="row.kelas"  v-if="JunShow" style="text-align:right">
                                    <span v-if="row.kode || row.rumus">{{row.junV | numFormat}}</span>
                                </td>

                                <td :class="row.kelas"  v-if="JulShow" style="text-align:right">
                                    <span v-if="row.kode || row.rumus">{{row.julB | numFormat}}</span>
                                </td>
                                <td :class="row.kelas"  v-if="JulShow" style="text-align:right">
                                    <b-link v-if="row.kode || row.rumus" @click="drillMonthly(row,row.jul,7)">{{row.jul | numFormat}}</b-link>
                                </td>
                                <td :class="row.kelas"  v-if="JulShow" style="text-align:right">
                                    <span v-if="row.kode || row.rumus">{{row.julV | numFormat}}</span>
                                </td>

                                <td :class="row.kelas"  v-if="AgtShow" style="text-align:right">
                                    <span v-if="row.kode || row.rumus">{{row.agtB | numFormat}}</span>
                                </td>
                                <td :class="row.kelas"  v-if="AgtShow" style="text-align:right">
                                    <b-link v-if="row.kode || row.rumus" @click="drillMonthly(row,row.agt,8)">{{row.agt | numFormat}}</b-link>
                                </td>
                                <td :class="row.kelas"  v-if="AgtShow" style="text-align:right">
                                    <span v-if="row.kode || row.rumus">{{row.agtV | numFormat}}</span>
                                </td>

                                <td :class="row.kelas"  v-if="SepShow" style="text-align:right">
                                    <span v-if="row.kode || row.rumus">{{row.sepB | numFormat}}</span>
                                </td>
                                <td :class="row.kelas"  v-if="SepShow" style="text-align:right">
                                    <b-link v-if="row.kode || row.rumus" @click="drillMonthly(row,row.sep,9)">{{row.sep | numFormat}}</b-link>
                                </td>
                                <td :class="row.kelas"  v-if="SepShow" style="text-align:right">
                                    <span v-if="row.kode || row.rumus">{{row.sepV | numFormat}}</span>
                                </td>

                                <td :class="row.kelas"  v-if="OktShow" style="text-align:right">
                                    <span v-if="row.kode || row.rumus">{{row.oktB | numFormat}}</span>
                                </td>
                                <td :class="row.kelas"  v-if="OktShow" style="text-align:right">
                                    <b-link v-if="row.kode || row.rumus" @click="drillMonthly(row,row.okt,10)">{{row.okt | numFormat}}</b-link>
                                </td>
                                <td :class="row.kelas"  v-if="OktShow" style="text-align:right">
                                    <span v-if="row.kode || row.rumus">{{row.oktV | numFormat}}</span>
                                </td>

                                <td :class="row.kelas"  v-if="NovShow" style="text-align:right">
                                    <span v-if="row.kode || row.rumus">{{row.novB | numFormat}}</span>
                                </td>
                                <td :class="row.kelas"  v-if="NovShow" style="text-align:right">
                                    <b-link v-if="row.kode || row.rumus" @click="drillMonthly(row,row.nov,11)">{{row.nov | numFormat}}</b-link>
                                </td>
                                <td :class="row.kelas"  v-if="NovShow" style="text-align:right">
                                    <span v-if="row.kode || row.rumus">{{row.novV | numFormat}}</span>
                                </td>

                                <td :class="row.kelas"  v-if="DesShow" style="text-align:right">
                                    <span v-if="row.kode || row.rumus">{{row.desB | numFormat}}</span>
                                </td>
                                <td :class="row.kelas"  v-if="DesShow" style="text-align:right">
                                    <b-link v-if="row.kode || row.rumus" @click="drillMonthly(row,row.des,12)">{{row.des | numFormat}}</b-link>
                                </td>
                                <td :class="row.kelas"  v-if="DesShow" style="text-align:right">
                                    <span v-if="row.kode || row.rumus">{{row.desV | numFormat}}</span>
                                </td>

                                <td :class="row.kelas" style="text-align:right">
                                    <span v-if="row.kode || row.rumus">{{row.ytdB | numFormat}}</span>
                                </td>
                                <td :class="row.kelas" style="text-align:right">
                                    <b-link v-if="row.kode || row.rumus" @click="drillMonToDate(row)">{{row.ytd | numFormat}}</b-link>
                                </td>
                                <td :class="row.kelas" style="text-align:right">
                                    <span v-if="row.kode || row.rumus">{{row.ytdV | numFormat}}</span>
                                </td>

                                <td :class="row.kelas" style="text-align:right">
                                    <span v-if="row.kode || row.rumus">{{row.totalB | numFormat}}</span>
                                </td>
                                <td :class="row.kelas" style="text-align:right">
                                    <span v-if="row.kode || row.rumus">{{row.total | numFormat}}</span>
                                </td>
                                <td :class="row.kelas" style="text-align:right">
                                    <span v-if="row.kode || row.rumus">{{row.totalV | numFormat}}</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </b-card>
        </b-card>
        <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
        <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
            <iframe :src="reportUrl" frameborder="0"></iframe>
        </b-modal>
        <b-modal v-model="lkuDeptShow" size="lg" :hide-footer="true" title="List of Department" :centered="true">
            <lku-department @click="onSelectLkuDept"></lku-department>
        </b-modal>        
    </div>
</template>

<style lang="scss" scoped>
    .report-wraper {
         width:100%;
         overflow-x: auto;
         overflow-y: auto;

        table {
            font-size: smaller;
            th {
                border-bottom: 1px solid #D1D1D1;
                padding: 0 15px;
                height: 30px;
                background: #e8e8e8;
            }              
            td {
                border-bottom: 1px solid #f5f5f5;
                padding: 0 10px;
                height: 25px;
            }
            
            td.tebal {
                font-weight: bold;
            }
            
            td.subtotal {
                border-top: 2px solid #000 !important;
            }
            
            td.total {
                border-top: 2px solid #000 !important;
                background: #e6e6e6 !important;
            }
            
            td.grdtotal {
                border-top: 2px solid #000!important;
                border-bottom: 2px solid #000 !important;
                background: #e6e6e6 !important;
            }
        }
    }
 
</style>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import lkuDepartment from "../lookup/lkuDepartment";
import budget_dept from "../../apis/budget_dept";
import dropdown from "../../data/dropdown";
import toastr from "mini-toastr";
import moment from 'moment';
import { validationMixin } from "vuelidate";
import { required,requiredIf } from "vuelidate/lib/validators";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    filter: {
        layout: { required },
        opsiDept: { required },
        DimCol: { required },
        departkd: {
                required: requiredIf(function () {
                    return this.filter.opsiDept==3
                })
            },
        tgl1: { required },
        tgl2: { required },
    },
  }, 
  data() {
    return {
      monthLabels: dropdown.monthLabels,
      filter: {layout:'', DimCol:'Department', departkd:'',tahun:moment(this.$store.state.user.tglaktif).format('YYYY')},
      model: {copysrc:0,markup:0,tahunsrc:parseInt(this.$store.state.user.tglaktif.substring(0,4))},
      lkuDeptShow:false,
      JanShow:true,
      FebShow:true,
      MarShow:true,
      AprShow:true,
      MeiShow:true,
      JunShow:true,
      JulShow:true,
      AgtShow:true,
      SepShow:true,
      OktShow:true,
      NovShow:true,
      DesShow:true,
      layouts:[],
      horizontal: true,
      isLoading: false,
      reportUrl: null,
      showReport:false,
      rptLines:[]
    };
  },
components: { lkuDepartment,Loading },  
computed:{
    invalidFilter() {
      this.$v.filter.$touch();
      return this.$v.filter.$invalid;
    },
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    layout() {
        return this.filter.layout;
    }
  },
watch:{
      layout: async function(newval) {
          this.rptLines= await budget_dept.layout({layout : newval});
      }
  },
created: async function (){
    //  this.layouts = await budget_dept.layout_combo();
    // if (this.$route.params.tgl1 && this.$route.params.tgl2 && this.$route.params.departkd && this.$route.params.layout) {
    //     this.filter.layout = this.$route.params.layout;
    //     this.filter.departkd = this.$route.params.departkd;
    //     this.filter.departemen = this.$route.params.departemen;
    //     this.filter.tgl1=this.$route.params.tgl1;
    //     this.filter.tgl2=this.$route.params.tgl2;
    //     this.filter.tahun=moment(this.params.tgl2, 'YYYY-MM-DD').format('YYYY');
    //     setTimeout(() => {
    //       this.process();
    //     }, 100);
    // } else {
    //     let bln = moment(this.$store.state.user.tglaktif, 'YYYY-MM-DD').month();
    //     let awal= parseInt(this.$store.state.user.awalbln || '1')-1;
    //     if ((bln-awal) > 10) {
    //         this.enableNextYear=true;
    //     }
    // }
     this.layouts = await budget_dept.layout_combo();
    var tgl2 = moment(this.$store.state.user.tglaktif, 'YYYY-MM-DD').add(1,'M').subtract(1, 'day');
    var tgl1 = moment(tgl2.format('YYYY') + '-01-01', 'YYYY-MM-DD');
    this.filter.tgl1=tgl1.format('YYYY-MM-DD');
    this.filter.tgl2=tgl2.format('YYYY-MM-DD');

     let bln = moment(this.$store.state.user.tglaktif, 'YYYY-MM-DD').month();
     let awal= parseInt(this.$store.state.user.awalbln || '1')-1;
     if ((bln-awal) > 10) {
         this.enableNextYear=true;
     }

  },
methods:{
    updateTgl1: function() {
        var tgl2 = moment(this.filter.tgl2, 'YYYY-MM-DD');
        var tgl1 = moment(tgl2.format('YYYY') + '-01-01', 'YYYY-MM-DD');
        this.filter.tgl1=tgl1.format('YYYY-MM-DD');
        this.filter.tahun=tgl1.format('YYYY');
    },
    onSelectLkuDept: async function (_selected) {
        this.lkuDeptShow=false;
        if (this.filter.DimCol=='Department') {
            this.filter.departemen = _selected.departkd.trim() + ' | ' + _selected.departemen.trim();
            this.filter.departid = _selected.departid;
            this.filter.departkd = _selected.departkd;
        } else  if (this.filter.DimCol=='Division') {
            this.filter.departemen = _selected.division;
            this.filter.departid = _selected.division;
            this.filter.departkd = _selected.division;
        } else {
            this.filter.departemen = _selected.directorate;
            this.filter.departid = _selected.directorate;
            this.filter.departkd = _selected.directorate;
        }

    },
    process: async function()
    {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
            this.isLoading=true;
            try {
                // Test Hak akses SUDAH BENAR,  jika api controller didaftar di sys_api
                this.rptLines=  await budget_dept.actualv2(this.filter);
                this.rptLines.forEach((row, idx) => {
                        this.rptLines[idx].janV = row.janB-row.jan;
                        this.rptLines[idx].febV = row.febB-row.feb;
                        this.rptLines[idx].marV = row.marB-row.mar;
                        this.rptLines[idx].aprV = row.aprB-row.apr;
                        this.rptLines[idx].meiV = row.meiB-row.mei;
                        this.rptLines[idx].junV = row.junB-row.jun;
                        this.rptLines[idx].julV = row.julB-row.jul;
                        this.rptLines[idx].agtV = row.agtB-row.agt;
                        this.rptLines[idx].sepV = row.sepB-row.sep;
                        this.rptLines[idx].oktV = row.oktB-row.okt;
                        this.rptLines[idx].novV = row.novB-row.nov;
                        this.rptLines[idx].desV = row.desB-row.des;
                        this.rptLines[idx].ytdV = row.ytdB-row.ytd;
                        this.rptLines[idx].totalV = row.totalB-row.total;
                });
                this.isLoading=false;    
            } catch (error) {
                this.isLoading=false;
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }   
            }
       }
    },
    exportxls: async function() {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
            this.isLoading=true;
            try {
                await budget_dept.actualv2export(this.filter);
                this.isLoading=false;    
            } catch (error) {
                this.isLoading=false;
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }   
            }
       }
    },
    drillMonthly: function(data,nilai,monthOf)
    {
        if (data.kode) {
        //     var tgl1 = moment(`${this.tahun}-${monthOf}-01`,'YYYY-MM-DD');
        //     let routeData = router.resolve({path: `ledger/${data.kode}/${tgl1.format('YYYY-MM-DD')}/${tgl1.add(1,'M').subtract(1, 'day').format('YYYY-MM-DD')}`});
        //     window.open(routeData.href, '_blank');
        // }
        // if ((data.kode) && (nilai)) {
                this.$bvModal.msgBoxConfirm(`Detail value of ${data.uraianfmt.toUpperCase() }, month of ${this.monthLabels[monthOf-1]} ?`, {
                title: 'Drilldown Confirmation',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'danger',
                okTitle: 'YES',
                cancelTitle: 'NO',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
                })
                .then(value => {
                    if (value==true) {
                        // var tgl1 = moment(`${this.tahun}-${monthOf}-01`,'YYYY-MM-DD');
                        // let routeData = router.resolve({path: `ledger/${data.kode}/${tgl1.format('YYYY-MM-DD')}/${tgl1.add(1,'M').subtract(1, 'day').format('YYYY-MM-DD')}`});
                        const tgl1= moment(`${this.tahun}-${monthOf}-01`,'YYYY-MM-DD');
                        const tgl2= moment(tgl1,'YYYY-MM-DD').add(1,'M').subtract(1, 'day').format('YYYY-MM-DD');

                        const routeData = router.resolve({path: `ledger/${data.kode}/${tgl1}/${tgl2}/${data.uraian}/${this.filter.departkd || '-'}/${this.filter.departemen || '-'}/${this.filter.opsiDept}/${this.filter.DimCol}`});
                        window.open(routeData.href, '_blank');
                    }
                })
                .catch(err => {
                    console.log('msgBoxConfirm error', err);
                })
        }

    },
    drillCurrentMonth: function(row)
    {
        if (data.kode) {
            // var tgl2 = moment(this.filter.tgl2, 'YYYY-MM-DD');
            // let routeData = router.resolve({path: `ledger/${data.kode}/${tgl2.format('YYYY-MM')}-01/${this.filter.tgl2}`});
            const tgl1= `${moment(this.filter.tgl2).format('YYYY-MM')}-01`;
            const tgl2= moment(this.filter.tgl2).format('YYYY-MM-DD');

            const routeData = router.resolve({path: `ledger/${data.kode}/${tgl1}/${tgl2}/${data.uraian}/${this.filter.departkd || '-'}/${this.filter.departemen || '-'}/${this.filter.opsiDept}/${this.filter.DimCol}`});
            window.open(routeData.href, '_blank');
        }
    },
    drillMonToDate: function(data)
    {
        if ((data.kode) && (data.ytd)) {
                this.$bvModal.msgBoxConfirm(`Detail value of ${data.uraianfmt.toUpperCase() }, as of ${moment(this.filter.tgl2).format('MMM YYYY').toUpperCase() } ?`, {
                title: 'Drilldown Confirmation',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'danger',
                okTitle: 'YES',
                cancelTitle: 'NO',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
                })
                .then(value => {
                    if (value==true) {
                        // let routeData = router.resolve({path: `ledger/${data.kode}/${this.filter.tgl1}/${this.filter.tgl2}`});
                        const tgl1= moment(this.filter.tgl1).format('YYYY-MM-DD');
                        const tgl2= moment(this.filter.tgl2).format('YYYY-MM-DD');
                        const routeData = router.resolve({path: `ledger/${data.kode}/${tgl1}/${tgl2}/${data.uraian}/${this.filter.departkd || '-'}/${this.filter.departemen || '-'}/${this.filter.opsiDept}/${this.filter.DimCol}`});
                        window.open(routeData.href, '_blank');
                    }
                })
                .catch(err => {
                    console.log('msgBoxConfirm error', err);
                })

        }
    },

    close(){
      router.push("home");
    }
  }
};
</script>
